import { StrategySafe } from 'utility-ts-strategy';

export interface ICourseStatus {
  humanString: string;
}

export type ap_course_status_type =
  | 'DEFAULT'
  | 'PLANNED'
  | 'REGISTERED'
  | 'SECTION_PICKED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'WAITLISTED'
  | 'MET'
  | '';

export const APCourseStatusStrategy = new StrategySafe<ICourseStatus, ap_course_status_type & 'FALLBACK'>({
  FALLBACK: {
    humanString: `Unregistered`
  },
  DEFAULT: {
    humanString: `Unregistered`
  },
  PLANNED: {
    humanString: `Planned`
  },
  SECTION_PICKED: {
    humanString: 'Section Picked'
  },
  REGISTERED: {
    humanString: `Enrolled`
  },
  IN_PROGRESS: {
    humanString: `In-progress`
  },
  COMPLETED: {
    humanString: `Completed`
  },
  WAITLISTED: {
    humanString: `Waitlisted`
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/strategies/ap_course_status_strategy.ts